import {
	ClientPortfolioDomainEnum,
	type LoanDetailDataDTO,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

type LoanPortfolio = PortfolioDetailResponseDTO & {
	data?: LoanDetailDataDTO | null;
};

export const isLoanPortfolio = (
	portfolio: PortfolioDetailResponseDTO,
): portfolio is LoanPortfolio =>
	portfolio.domain === ClientPortfolioDomainEnum.Loans;
